export const getDailyReports = async (resource, page) => {
    let result
    await resource
        .get(`api/${localStorage.getItem('perfil')}/daily_report?page=${page}`)
        .then(
            (response) => {
                result = response.body.daily_report
            },
            (response) => {
                console.log(response);
            }
        );
    return result;
}
export const getDailyReport = async (resource, id) => {
    let result
    await resource
        .get(`api/${localStorage.getItem('perfil')}/daily_report/${id}`)
        .then(
            (response) => {
                result = response.body.daily_report
            },
            (response) => {
                console.log(response);
            }
        );
    return result;
}

export const storeDailyReport = async (resource, data) => {
    let result
    await resource
        .post(`api/${localStorage.getItem('perfil')}/daily_report`, data)
        .then(
            (response) => {
                result = response.body.daily_report
            },
            (response) => {
                console.log(response);
            }
        );
    return result;
}